import React from 'react';
import mapContext from '../contexts/map-context';
import { useSearchByDealerId } from './useSearchByDealerId';
import { ActionTypes } from '../contexts/reducers/map-reducer';

export function useResultByDealerId() {
  const dispatch = mapContext.useMapDispatch();
  const { selectedDealerId } = mapContext.useMapState();
  const { loading, error, dealer } = useSearchByDealerId(selectedDealerId);

  React.useEffect(() => {
    if (error) {
      dispatch({
        type: ActionTypes.setSearchError,
        payload: error,
      });
    }
  }, [error]);

  React.useEffect(() => {
    if (loading) {
      dispatch({
        type: ActionTypes.setLoading,
        payload: true,
      });
      dispatch({ type: ActionTypes.setSearchRadiusExtended, payload: false });
    }
  }, [loading]);

  React.useEffect(() => {
    if (!loading && dealer) {
      dispatch({
        type: ActionTypes.setLoading,
        payload: false,
      });
      dispatch({
        type: ActionTypes.setSearchError,
        payload: null,
      });
    }
  }, [dealer, loading]);
}
